export enum RollingDirection {
  PARALLEL = "PARALLEL",
  ORTHOGONAL = "ORTHOGONAL",
  NO_PREFERENCE = "NO_PREFERENCE",
}
